import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { Todo } from '../../../../../types/types';
import { useTodos } from '../../../../../context/TodoContext/TodoContext';

export const useEventItem = (todo: Todo) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editText, setEditText] = useState(todo.text);
    const inputRef = useRef<HTMLInputElement>(null);
    const { editTodo } = useTodos();

    useEffect(() => {
        setEditText(todo.text);
    }, [todo.text]);

    useEffect(() => {
        if (isEditing && inputRef.current) {
            const input = inputRef.current;
            input.focus();
            input.setSelectionRange(input.value.length, input.value.length);
        }
    }, [isEditing]);

    const handleEdit = () => {
        setEditText(todo.text);
        setIsEditing(true);
        requestAnimationFrame(() => {
            setIsEditing(true);
            requestAnimationFrame(() => {
                inputRef.current?.focus();
                inputRef.current?.setSelectionRange(
                    inputRef.current?.value.length,
                    inputRef.current?.value.length
                );
            });
        });
    };

    const handleSave = () => {
        if (editText.trim() && editText !== todo.text) {
            const updatedTodo: Todo = {
                ...todo,
                text: editText.trim(),
                updatedAt: dayjs()
            };
            editTodo(todo.id, updatedTodo);
        }
        setIsEditing(false);
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSave();
        } else if (e.key === 'Escape') {
            setIsEditing(false);
            setEditText(todo.text);
        }
    };

    const handleTextChange = (text: string) => setEditText(text);

    return {
        isEditing,
        editText,
        handleEdit,
        handleSave,
        handleKeyPress,
        handleTextChange,
        inputRef
    };
}; 